module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/dream_plan_list_header.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/dream_plan_list_header.png
// module id = 2035
// module chunks = 367